import * as IconsBrand from "@fortawesome/free-brands-svg-icons";
import * as IconsSolid from "@fortawesome/free-solid-svg-icons";

export const iconListBrand = Object
  .keys(IconsBrand)
  .filter((key) => key !== 'fas' && key !== 'prefix')
  .map((icon) => IconsBrand[icon])

export const iconListSolid = Object
  .keys(IconsSolid)
  .filter((key) => key !== 'fas' && key !== 'prefix')
  .map((icon) => IconsSolid[icon])